import { gql } from '@apollo/client';

export const GET_STYLING_SESSIONS = gql`
    query getStylingSessions {
        getStylingSessions {
            customer
            stylist
            eventUri
            inviteeUri
        }
    }
`;

export const GET_MY_SESSIONS = gql`
    query GetMySessions($input: GetMySessionsInput!) {
        getMySessions(input: $input) {
            data {
                id
                taffiId
                stylingSessionReason {
                    id
                    title
                    value
                    isSomethingElse
                }
                subReason
                customer {
                    id
                    firstName
                    lastName
                    userName
                    profileImageUrl
                }
                stylist {
                    id
                    firstName
                    lastName
                    userName
                    level {
                        value
                        imageUrl
                    }
                    profileImageUrl
                }
                eventUri
                inviteeUri
                cancelUri
                rescheduleUri
                stylistEventUri
                startTime
                endTime
                meetingUrl
                meetingType
                status
                store {
                    id
                    taffiId
                    name
                    description
                    url
                    logoImageUrl
                    platform
                }
                needSessionWithStylist
                requestStatus
                answers {
                    id
                    userId
                    questionId
                    contextType
                    contextId
                    value
                    questionDataIds
                    questionsData {
                        id
                        subject
                        title
                        value
                        type
                        displayOrder
                        enabled
                    }
                }
            }
            paging {
                size
                page
            }
        }
    }
`;

export const GET_SESSION_DETAIL = gql`
    query GetSessionDetails($input: GetSessionDetailsInput!) {
        getSessionDetails(input: $input) {
            id
            taffiId
            stylingSessionReason {
                id
                title
                value
                isSomethingElse
            }
            subReason
            customer {
                id
                email
                firstName
                lastName
                userName
                profileImageUrl
            }
            stylist {
                id
                email
                firstName
                lastName
                email
                connectedApps {
                    app
                    schedulingLink
                    status
                }
                userName
                level {
                    title
                    value
                    imageUrl
                }
                profileImageUrl
                availableForStylingSessions
            }
            eventUri
            inviteeUri
            cancelUri
            rescheduleUri
            stylistEventUri
            startTime
            endTime
            meetingUrl
            meetingType
            status
            cancellation {
                cancelBy
                reason
                cancellerType
            }
            store {
                id
                taffiId
                name
                description
                url
                logoImageUrl
                platform
            }
            needSessionWithStylist
            requestStatus
            answers {
                id
                userId
                questionId
                contextType
                contextId
                value
                questionDataIds
                questionsData {
                    id
                    subject
                    title
                    value
                    type
                    displayOrder
                    enabled
                }
            }
        }
    }
`;

export const GET_SESSIONS_BY_USER_ID = gql`
    query GetSessionsByUserId($input: GetSessionsByUserIdInput!) {
        getSessionsByUserId(input: $input) {
            data {
                id
                taffiId
                stylingSessionReason {
                    id
                    title
                    value
                    isSomethingElse
                }
                subReason
                customer {
                    id
                    phone
                    firstName
                    lastName
                    email
                    gender
                    userType
                    approved
                    userName
                    bio
                    profileImageUrl
                    storeIds
                    stores {
                        id
                        taffiId
                        name
                        url
                    }
                    currency
                    quizCompleted
                }
                stylist {
                    id
                    firstName
                    lastName
                    email
                    userName
                    level {
                        value
                        imageUrl
                    }
                    profileImageUrl
                }
                eventUri
                inviteeUri
                cancelUri
                rescheduleUri
                stylistEventUri
                startTime
                endTime
                meetingUrl
                meetingType
                status
                resheduling
                store {
                    id
                    name
                    url
                }
                needSessionWithStylist
                requestStatus
                answers {
                    id
                    userId
                    questionId
                    contextType
                    contextId
                    value
                    questionDataIds
                    questionsData {
                        id
                        subject
                        title
                        value
                        type
                        displayOrder
                        enabled
                    }
                }
            }
            paging {
                size
                page
            }
        }
    }
`;

export const GET_SESSION_STYLIST_NOTES = gql`
    query GetSessionStylistNotes($input: GetStylistNotesInput!) {
        getStylistNotes(input: $input) {
            data {
                id
                note
                creator
                taffiId
                sessionId
                sessionTaffiId
            }
        }
    }
`;
